import React from "react";
import { SubPageNav, SubPageFoot, ArrowIcon, BOOK_URL } from "../components/SubPageChrome";
import "./HomePage.css";

const ErrorPage: React.FC = () => {
  return (
    <div className="home-v2">
      <SubPageNav ctaLabel="Book Now" ctaHref={BOOK_URL} />

      <section className="v2-page-hero">
        <div className="v2-container">
          <div className="kicker">404 / Not Found</div>
          <h1>
            Out of <em>bounds.</em>
          </h1>
          <p className="lede">
            We couldn't find that page. It may have moved, or you may have
            followed a broken link. Let's get you back on court.
          </p>
          <div className="v2-hero-actions" style={{ marginTop: 32 }}>
            <a href="/" className="v2-btn v2-btn-on-light">
              Back to Home
              <ArrowIcon />
            </a>
            <a href="mailto:info@tempo.club" className="v2-btn v2-btn-ghost">
              info@tempo.club
            </a>
          </div>
        </div>
      </section>

      <SubPageFoot />
    </div>
  );
};

export default ErrorPage;
